<template>
 <div class="index-header">

    <div class="nav" :style="navStyle">
        <div class="img-icon">
            <img src="@/assets/imgs/meishuguan.png" alt="" :style="imgStyle">
        </div>
        <div class="menu">
            <ul>
                  <li>
                    <router-link to="/index">首页</router-link>
                  </li>
                  <li>
                    <router-link to="/introduction">美术馆简介</router-link>
                  </li>
                  <li>
                    <router-link to="/newsInfo">新闻资讯</router-link>
                      <ul>
                          <li>
                                <router-link to="/notice">通知公告</router-link>
                          </li>
                          <li>
                                <router-link to="/musInfo">馆内动态</router-link>
                          </li>
                          <li>
                                <router-link to="/medInfo">媒体报道</router-link>
                          </li>
                      </ul>
                  </li>
                  <li>
                    <router-link to="/appreciate"> 馆藏鉴赏</router-link>
                     <ul>
                          <li>
                                <router-link to="/appreciate/vtour">VR展示</router-link>
                          </li>
                     </ul>
                  </li>
                  <li>
                    <router-link to="/exchange"> 学术交流</router-link>
                         <ul>
                          <li>
                                <router-link to="/study">学术研究</router-link>
                          </li>
                          <li>
                                <router-link to="/activities">学术活动</router-link>
                          </li>
                      </ul>
                  </li>
                      <li>
                    <router-link to="/display"> 陈列展览</router-link>
                        <ul>
                          <li>
                                <router-link to="/nowplay">正在展览</router-link>
                          </li>
                          <li>
                                <router-link to="/displayYugao">展览预告</router-link>
                          </li>
                          <li>
                                <router-link to="/displayreview">展览回顾</router-link>
                          </li>
                      </ul>
                  </li>
                  <li>
                    <router-link to="/education"> 公共教育</router-link>
                  </li>
                  <li>
                      <router-link to="/spectatorService"> 观众服务</router-link>
                      <ul>
                          <li>
                                <router-link to="/spectatorService/appointment">参观预约</router-link>
                          </li>
                          <li>
                                <router-link to="/spectatorService/guide">服务指南</router-link>
                          </li>
                           <li>
                                <router-link to="/spectatorService/electronicMessage">电子留言</router-link>
                          </li>
                           <li>
                                <router-link to="/spectatorService/onlineSurvey">在线调查</router-link>
                          </li>
                      </ul>
                  </li>
                  <li>
                      <router-link to="/volunteer/home"> 志愿者之家</router-link>
                      <ul>
                          <li>
                                <router-link to="/volunteer/home/rule">志愿者章程</router-link>
                          </li>
                          <li>
                                <router-link to="/volunteer/home/activity">志愿者活动</router-link>
                          </li>
                      </ul>
                  </li>
            </ul>
        </div>
        </div>
 </div>
</template>

<script>

export default {
  name: 'indexHeader',
  props: {
  },
   data() {
      return {
        firstPage:true,
        navStyle:{backgroundColor:''},
        imgStyle:{display:'none'}
      };
    },
  mounted:function(){
         window.addEventListener('scroll', this.handleScroll);
    //this.initWindowScroll();
    this.handleMenuShow();
  },
  created()
  {
     
  },
  
watch:{
  "$route": function(route){
          if (route.name != '首页')
          {
           
              this.firstPage = false;
              this.handleMenuShow();
              this.removeNavShow();
              this.imgStyle.display = 'block';
              this.navStyle.backgroundColor = 'rgba(183,140,13,0.8)';
          }
          else
          {
              this.imgStyle.display = 'none';
              this.navStyle.backgroundColor = '';
              this.firstPage = true;
              this.handelNavShow();
          }
       
    }
},
  methods:{

      handleScroll()
      {
           var that = this;
       
           var top = document.documentElement.scrollTop|| document.body.scrollTop;
            if (top > 0)
            {
                   that.imgStyle.display = 'block';
                   that.navStyle.backgroundColor = 'rgba(183,140,13,0.8)';
            }
            else
            {
              if (that.firstPage)
              {
                  that.imgStyle.display = 'none';
                  that.navStyle.backgroundColor = '';
              }
              else
              {
                  that.navStyle.backgroundColor = 'rgba(183,140,13,0.8)';
                  that.imgStyle.display = 'block';
              }
            
            }
      
      },
      handleMenuShow()
      {

        var lis = document.querySelectorAll(".index-header .nav .menu ul li");
        for (var i = 0; i < lis.length; i++)
        {
             lis[i].addEventListener("mouseover",function(){
                 let ul =   this.getElementsByTagName('ul')
                 if(ul && ul.length > 0)
                 {
                        ul[0].style.display ="block";
                 }
             });
            lis[i].addEventListener("mouseout",function(){
     
                 let ul =   this.getElementsByTagName('ul')
                 if(ul && ul.length > 0)
                 {
                        ul[0].style.display ="none";
                 }
             })
        }
      },
    mouseoverHandle(){
　　　　   this.navStyle.backgroundColor = 'rgba(183,140,13,0.8)';
          this.imgStyle.display = 'block';
　　},
  mouseoutHandle(){
　　　　         this.imgStyle.display = 'none';
                  this.navStyle.backgroundColor = '';
　　},
      handelNavShow()
      {
        var navs = document.querySelectorAll(".index-header .nav");
        if (navs && navs.length > 0)
        {
              let fnc = this.mouseoverHandle();
               navs[0].addEventListener("mouseover",this.mouseoverHandle)
               navs[0].addEventListener("mouseout",this.mouseoutHandle)
        }
      },
      removeNavShow()
      {

        var navs = document.querySelectorAll(".index-header .nav");
        if (navs && navs.length > 0)
        {
              navs[0].removeEventListener("mouseover", this.mouseoverHandle)
              navs[0].removeEventListener("mouseout", this.mouseoutHandle)
        }
      }
      
  }
}
</script>


<style scoped>



@import "../assets/style/indexHeader/index-header.css";


</style>
